import { IRender } from '../parseTreeToHtml.types';

export const linkRender: IRender = (text, data): string => {
  if (!text || !data) {
    return '';
  }

  return `<a href="${data.link}" target="_blank">${text}</a>`;
};
